import React, { useState, useRef, memo } from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";
import SliderButton from "../../SliderEasySplit/SliderButton";
import Image from "../../Image";
import "./StackMerchantSlider.scss";

function StackMerchantSlider({ data, settings, quoteStyling }) {
  const [activeSlide, setActiveSlide] = useState(0);
  const slider = useRef(null);
  const onPrev = () => {
    slider?.current?.slickPrev();
  };
  return (
    <div className="stack-merchant-slider min-h-[400px] flex flex-wrap text-left relative">
      <SliderButton
        className={`absolute mob-hidden md:flex top-1/2 -left-6 `}
        onClick={onPrev}
      />
      <div className="w-full md:w-1/2 relative hidden md:flex min-h-[300px] md:min-h-[390px] overflow-hidden">
        {data.map((d, index) => (
          <Image
            key={d.id}
            src={d.image}
            alt={d.name}
            width="610"
            height="390"
            className={`absolute left-0 top-0 object-cover w-full h-full opacity-0 transition-opacity ${
              activeSlide === index ? "opacity-100" : ""
            }`}
          />
        ))}
      </div>
      <div className="w-full md:w-1/2 md:px-[24px] xl:pl-[38px] relative self-center pt-4 pb-12 md:py-0">
        <Slider
          {...settings}
          beforeChange={(_, nextIndex) => {
            setActiveSlide(nextIndex);
          }}
          ref={slider}>
          {data.map((d) => (
            <div key={d.id} className="item">
              <div className="flex flex-col">
                <div className="block md:hidden overflow-hidden mb-4">
                  <Image
                    key={d.id}
                    src={d.image}
                    alt={d.name}
                    width="610"
                    height="390"
                    className="object-cover w-full h-[300px]"
                  />
                </div>
                <div className={quoteStyling}>{d.quote}</div>
                <Image {...d.companyLogo} className="mb-2.5" />
                <div className="text-md">
                  <div className="text-[#240253] font-semibold">{d.name}</div>
                  <div className="text-[#240253]">{d.designation}</div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

StackMerchantSlider.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      image: PropTypes.string,
      companyLogo: PropTypes.shape({
        src: PropTypes.string,
        width: PropTypes.string,
        height: PropTypes.string,
        alt: PropTypes.string,
      }),
      name: PropTypes.string,
      designation: PropTypes.string,
      quote: PropTypes.string,
    }),
  ),
  settings: PropTypes.shape({}),
  quoteStyling: PropTypes.string,
};

StackMerchantSlider.defaultProps = {
  data: [],
  settings: {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SliderButton left={false} />,
    prevArrow: <SliderButton />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: true,
        },
      },
    ],
  },
  quoteStyling:
    "text-md md:text-3md mb-5 md:mb-10 font-medium max-w-[534px] md:pr-[20px] text-[#240253]",
};

export default memo(StackMerchantSlider);
